import {dataInterface} from "@/apis/data";

export const getNotRead = async (userInfo) => {
  try {
    const res = await dataInterface({ user_id: userInfo.id },'api/notify/getUserNotIsRead','POST');
    if (res.data.code === 200) {
      return res?.data?.data || [];
    }
    return [];
  } catch (error) {
    return [];
  }
};